import Login from './components/Login';
import PublicTable from './components/PublicTable'
import DropRoute from './components/DropRoute';
import About from './components/About'
import Contact from './components/Contact'
import { DropProvider } from './contexts/DropContext';
import { 
  BrowserRouter,
  Routes,
  Route,
  Navigate
} from 'react-router-dom';
import React from 'react';
import Dropdown from './components/Dropdown';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import Header from './components/Header';
import Footer from './components/Footer';
import ProjectPage from './components/ProjectPage';

const queryClient = new QueryClient();


function App(){

  return (
  <BrowserRouter>
  <div className='portal-shell'>
      <DropProvider>
            <Header />
            <Routes>
              <Route path='/projects' element={<Dropdown />}/>
              <Route path='/datasets' element={<Navigate to='/projects' replace />}/>
              <Route path='/projects/:projectId' element={<ProjectPage />}/>
              <Route path='/table' 
                element={
                  <QueryClientProvider client={queryClient}>
                      <DropRoute>
                        <PublicTable />
                      </DropRoute>
                    <ReactQueryDevtools initialIsOpen={false} />
                  </QueryClientProvider>

                }/> 
              <Route path='/' element={<Navigate to='/projects' replace />}/>
              <Route path='/login' element={< Login />}/>
              <Route path='/about' element={<About />}/>
              <Route path='/contact' element={<Contact />}/>
              <Route path='/notebooks' element={<Navigate to='/projects' replace />}/>
            </Routes>
            <Footer />
      </DropProvider>
  </div>
  </BrowserRouter>
  )
}
export default App